import { Routes } from '@angular/router';
import { AccountManagerGuard } from '@shared/guards/account-manager.guard';
import { OktaAuthGuard } from '@okta/okta-angular';
import { unauthenticatedGuard } from '@shared/guards/unauthenticated.guard';
import { userGuard } from '@shared/guards/user.guard';
import { adminMenuGuard } from '@shared/guards/admin-menu.guard';
import { purchaseMenuGuard } from '@shared/guards/purchase-menu.guard';
import { enableCommentsGuard } from '@shared/guards/comments-enabled.guard';
import { CustomCallbackComponent } from '@shared/components/organisms/custom-callback/custom-callback.component';
import { OktaAuthCallbackComponent } from '@shared/components/organisms/oktaauth-callback/oktaauth-callback';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [OktaAuthGuard],
    children: [
      {
        path: '',
        canActivateChild: [AccountManagerGuard],
        children: [
          {
            path: 'home',
            loadChildren: () => import('./features/home/home.routes').then((r) => r.HOME_ROUTES),
          },
          {
            path: 'admin',
            loadChildren: () => import('./features/admin/admin.routes').then((r) => r.ADMIN_ROUTES),
            canActivateChild: [userGuard, adminMenuGuard]
          },
          {
            path: 'whats-new',
            loadChildren: () => import('./features/whats-new/whats-new.routes').then((m) => m.WHATS_NEW_ROUTES),
          },
          {
            path: 'coming-soon',
            loadChildren: () => import('./features/coming-soon/coming-soon.routes').then((m) => m.COMING_SOON_ROUTES),
          },
          {
            path: 'calculator',
            loadChildren: () => import('./features/calculator/calculator.routes').then((r) => r.CALCULATOR_ROUTES),
          },
          {
            path: 'search-history',
            loadChildren: () => import('./features/search-history/search-history.routes').then((r) => r.SEARCH_HISTORY_ROUTES),
            canActivateChild: [userGuard]
          },
          {
            path: 'favorites',
            loadChildren: () => import('./features/favorites/favorites.routes').then((r) => r.FAVORITES_ROUTES),
            canActivateChild: [userGuard]
          },
          {
            path: 'synonyms',
            loadChildren: () => import('./features/synonyms/synonyms.routes').then((r) => r.SYNONYMS_ROUTES),
          },
          {
            path: 'comments',
            loadChildren: () => import('./features/comments/comment.routes').then((r) => r.COMMENTS_ROUTES),
            canActivate: [enableCommentsGuard],
          },
          {
            path: 'nmfc-book',
            loadChildren: () => import('./features/nmfc-book/nmfc-book.routes').then((r) => r.NMFC_BOOK_ROUTES),
          },
          {
            path: 'company-common',
            loadChildren: () =>
              import('./features/company-common/company-common.routes').then((r) => r.COMPANY_COMMON_ROUTES),
          },
          {
            path: 'shared-bookmarks',
            loadChildren: () => import('./features/nmfc-book/components/shared-bookmarks/shared-bookmarks.routes').then((m) => m.SHARED_BOOKMARKS_ROUTES),
          },
        ],
      },
      {
        path: 'profile',
        loadChildren: () => import('./features/profile/profile.routes').then((r) => r.PROFILE_ROUTES),
        canActivateChild: [userGuard]
      },
    ],
  },
  {
    path: 'purchase',
    canActivateChild: [purchaseMenuGuard],
    loadChildren: () => import('./features/purchase/purchase.routes').then((r) => r.PURCHASE_ROUTES),
  },
  { path: 'login/callback', component: CustomCallbackComponent },
  // { path: 'auth', component: OktaAuthCallbackComponent },
  {
    path: 'welcome',
    canActivate: [unauthenticatedGuard],
    loadComponent: () => import('./features/welcome/welcome.component').then((m) => m.WelcomeComponent),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
